import { DEFAULTS } from "./defaults";
import { FILE_UPLOAD_TYPE } from "./types";
import { nodeViewRenderers } from "./viewer/nodeViewRenderers-loadable";
const pluginFileUpload = (config) => {
  return {
    config: { ...DEFAULTS.configViewer, ...config },
    type: FILE_UPLOAD_TYPE,
    nodeViewRenderers
  };
};
export {
  pluginFileUpload
};
//# sourceMappingURL=viewer-loadable.js.map
